import api from "../configs/api";
import { Totem, Wallet, Client } from "../types";

export const getWalletByClient = async (client: string): Promise<Wallet | false> => {
  try {
    const payload = {
      clientId: client,
      localDate: new Date().toString(),
    };

    const [{ status, data }, clientResponse] = await Promise.all([
      api.post('/client-order/client/balance/period', payload),
      api.get(`/clients/field/id/value/${client}`),
    ]);

    if (status !== 200) throw new Error();

    return { ...data, cardBalanceInCents: clientResponse.data.virtualCard?.balance } as Wallet;
  } catch (error) {
    return false;
  }
};

export const getClientById = async (id: string): Promise<Totem | false> => {
  try {
    const { status, data } = await api.get(`/clients/field/id/value/${id}`);

    if (status !== 200) throw new Error();

    return data as Totem;
  } catch (error) {
    return false;
  }
};

export const getTotemClients = async (entityID: string): Promise<Client[] | false> => {
  try {
    const { status, data } = await api.get(`/totem/entity/${entityID}/clients`);

    if (status !== 200) throw new Error();

    return data as Client[];
  } catch (error) {
    return false;
  }
};
